import { KAPTIVO_POPOUT, WEBAPP_CLOSE_WHITEBOARD_POPOUT, WEBAPP_OPEN_WHITEBOARD_POPOUT } from 'constants/PluginConstants';

export function openWhiteboardDesktop(url) {
  return (dispatch) => {
    dispatch({ type: KAPTIVO_POPOUT, payload: { url: url } });
  };
}

export function openWhiteboardWebapp(url) {
  return (dispatch) => {
    dispatch({ type: WEBAPP_OPEN_WHITEBOARD_POPOUT, payload: { url: url } });
  };
}

export function closeWhiteboardWebapp() {
  return (dispatch) => {
    dispatch({ type: WEBAPP_CLOSE_WHITEBOARD_POPOUT });
  };
}
